<template lang="pug">

  .question
    .question__wrap
      .container
        .row
          transition(name="fade" mode="out-in")
            .question__list.col-12.col-md-6.offset-md-1(:key="currQuest.id" ref="list")
              h2.title.title--30(:class="{ isBig: bigTitle}") {{ title }}
              br
              p(v-show="subtitle") {{ subtitle }}
              AnswersList(
              ref="list"
              :questData="currQuest"
              :isFirst="isFirstQuestion"
              @next="next"
              :choosed="choosedAnswerId"
              @answer="submitAnswer"
              :class="{ answers__list_active : choosedAnswerId !== null }")
          .question__info.col-12.col-md-5
            .dots.dots--top(ref="dots")
            .app-status
              .app-status__pic(:class="{ 'app-status__pic_first': isFirstQuestion }")
                ManImage(
                :isFirst="isFirstQuestion"
                :painLevel="painLevel")
              transition(name="fade")
                ProgressBars(v-if="!isFirstQuestion" :status="getStatus")
    StatusBar(
    :questionsLength="questLength",
    :activeQuestion="currQuest",
    :isFirst="isFirstQuestion")
</template>

<script>
  import { mapGetters, mapMutations, mapState } from 'vuex';
  import ProgressBars from '@/components/ProgressBars.vue';
  import AnswersList from '@/components/AnswersList.vue';
  import StatusBar from '@/components/StatusBar.vue';
  import ManImage from '@/components/ManImage.vue';

  import anime from 'animejs';

  export default {
    name: 'Question',
    components: {
      ProgressBars,
      AnswersList,
      StatusBar,
      ManImage,
    },
    data () {
      return {
        complete: false,
        choosedAnswerId: null,
        background: {
          color: '#fff',
        },
        isChanging: false,
        scroll: {
          y: window.pageYOffset,
        },
      };
    },
    computed: {
      ...mapState([
        'isFail',
        'activeQuestion',
      ]),
      ...mapGetters([
        'currQuest',
        'isFirstQuestion',
        'getStatus',
        'questLength',
      ]),
      mobileBar () {
        return window.innerWidth < 768 && this.isFirstQuestion;
      },
      bigTitle () {
        return this.currQuest.title.length > 50;
      },
      title () {
        return this.currQuest.title;
      },
      subtitle () {
        return this.currQuest.subtitle || null;
      },
      painLevel () {
        return this.getStatus.pain;
      },
    },
    methods: {
      ...mapMutations([
        'changeScore',
        'nextQuestion',
        'setChoosedAnswer',
        'calcModificators',
        'setScenarios',
        'changeBackgroundColor',
      ]),
      submitAnswer (id) {

        if (this.complete) {
          return;
        }

        this.complete = true;
        this.choosedAnswerId = id;

        this.setChoosedAnswer(id);

        if (this.isFirstQuestion) {
          // Высчитываем значения для балов
          this.calcModificators();
          return;
        }

        this.currQuest.answers[id].modificator.forEach((value, index) => {
          if (value === 0) {
            return;
          }
          let operator = (value >= 0) ? '+' : '-';
          this.changeScore({operator: operator, type: index, value: value});
        });

      },
      next () {

        if (this.isChanging) {
          return;
        }

        this.isChanging = true;

        anime({
          targets: this.$refs.dots,
          duration: 500,
          height: 0,
        });

        this.changeQuestion();
        this.choosedAnswerId = null;
        this.isChanging = false;

        this.$nextTick(() => {
          window.scroll({
            top: 0,
            behavior: 'smooth',
          });
        });

      },
      changeQuestion () {
        if (this.isFirstQuestion) {
          this.setScenarios(this.choosedAnswerId);
          this.changeBackgroundColor();
        } else {
          this.nextQuestion();
        }
      },
    },
    mounted () {
      this.changeBackgroundColor();
    },
    beforeUpdate () {
      this.visible = false;
    },
    updated () {
      const appContainer = document.querySelector('.question__info');
      const appStatus = document.querySelector('.app-status');
      const appClassToggle = 'app-status_fixed';

      if (window.innerWidth < 768) {
        if (this.isFirstQuestion) {
          return false;
        }
        if (!this.complete) {
          appStatus.classList.remove(appClassToggle);
        }

        appContainer.style.height = `${appStatus.offsetHeight}px`;
        window.onscroll = function () {
          var scrolled = window.pageYOffset || document.documentElement.scrollTop;
          if (scrolled > 170) {
            appStatus.classList.add(appClassToggle);
          } else {
            appStatus.classList.remove(appClassToggle);
          }
        };
      } else {
        appContainer.style.height = '';
      }
    },
    watch: {
      currQuest: {
        handler () {
          this.complete = false;
        },
        deep: true,
      },
    },
  };
</script>

<style lang="stylus">
  .question
    &__wrap
      display: flex
      flex-flow: row wrap
      justify-content: center
      align-items: center
      min-height: calc(100vh - 13rem)

      @media (min-width: 769px)
        align-items: flex-start

      & > .container
        margin: 0

    &__list
      order 2
      @media $tablet
        order 1
      .title.isBig
        font-size: 1.8rem
        @media $tablet
          font-size: 2.4rem
    &__info
      display flex
      align-items flex-start
      order 1
      margin-bottom 3rem
      @media $tablet
        overflow: hidden
        display block
        order 2
        margin-bottom 0
        will-change transform

    .dots--top
      position absolute
      right: 2rem
      bottom -1rem
      top 0
      z-index 1
      @media $tablet
        position static
        margin 0 auto 4rem

  .app-status
    display flex
    align-items: center
    width 100%
    transition all 0.75s $easeOutExpo
    @media $tablet
      align-items: flex-start
      display block
    &__pic
      width 42%
      margin-right 2rem
      position: relative
      @media $tablet
        width 30.1rem
        height auto
        margin-right auto
        margin-left auto
        margin-bottom 2rem
      img
        display block
        width 100%
        max-height: 100%
      &_first
        margin 0 auto
    &_fixed
      position fixed
      top 0
      left 0
      right 0

      z-index 50
      display flex
      align-items center
      padding 1rem 2rem

      background: rgba($white, 0.9)
      box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.30)
      .app-status
        &__pic
          width 5.3rem
          height 6rem
          margin-right 2rem
          margin-bottom 0

      .bars-item
        display flex
        align-items center
        margin-bottom 0.6rem

        font-weight: 600
        font-size: 1rem
        &:last-child
          margin-bottom 0

        &__shadow
          display: none
        &__progress
          width 8rem
          height 1rem
          order 2
          border-width 1px
          margin-top 0
          margin-right 0.8rem

          .isPain &
            width: calc(100% - 5px)
            height: calc(100% - 1.5px)

        &__status
          order 3
          text-align left
        &__indicator
          background-size 13rem 0.8rem

        &__name
          display none
        .bars-item_danger
          .bars
            &-item
              &__indicator
                background-size 6rem 0.8rem

      .isPain .bars-item__indicator
        width: calc(100% - 5px)
        height: calc(100% - 1.55px)
        margin-top: 1px
        margin-left: 3px

</style>
